import React, { PropsWithChildren } from 'react';

interface ChartContainerProps extends PropsWithChildren {
  height?: string;
}

export default function ChartContainer({ children, height = '30rem' }: ChartContainerProps) {
  return (
    <div className="position-relative w-100 mt-lg-5" style={{ height }}>
      <div className="position-absolute top-0 left-0 w-100 h-100">
        {children}
      </div>
    </div>
  );
}
